const DEVICE_ID_KEY = "bmd-device-id";

const createDeviceId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `web-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

export const getDeviceId = (): string => {
  const existing = localStorage.getItem(DEVICE_ID_KEY);
  if (existing) {
    return existing;
  }
  const id = createDeviceId();
  localStorage.setItem(DEVICE_ID_KEY, id);
  return id;
};

export const getDeviceName = (): string => {
  if (typeof navigator === "undefined") {
    return "BMD Chat Web";
  }
  return navigator.userAgent || "BMD Chat Web";
};
